export const BOOKEEPER_SELECT_DROPDOWN_ID = 'invite-bookkeeper-modal-bookeeper-select-dropdown-id'
